import {tokensForThemeProvider} from '@forecast-it/design-system';

const {sys, ref} = tokensForThemeProvider.sky;

/** Colours used by the Baseline versions UI. */
export const C = {
	brand: sys.color.background.primary['3'],
	brandTint: sys.color.background.primary['1'],
	text: sys.color.text.content.main,
	aux: sys.color.text.content.auxiliary,
	onDark: sys.color.text.content.ondark,
	success: sys.color.text.semantic.success,
	successTint: ref.color.green['50'],
	fill: ref.color.green['300'],
	navy: ref.color.coolneutral['900'],
	navyLabel: ref.color.coolneutral['200'],
	border: sys.color.border.decorative,
	borderDisabled: sys.color.border.disabled,
	surface: sys.color.background.neutral['1'],
	tint: sys.color.background.neutral['2'],
	error: sys.color.text.semantic.error,
};

/** Type styles as CSS declarations, for use inside styled-components templates. */
export const F = {
	sub1: sys.font.subheading['1'],
	sub2: sys.font.subheading['2'],
	body1: sys.font.body['1'],
	body2: sys.font.body['2'],
	detail: sys.font.detail['1'],
	h4: sys.font.heading['4'],
};
